import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import { ChildDocumentCard } from "@/module/components/components";
import { useActiveDataMutation } from "@/features/leads/hook/useActiveDataMutation";

export default function DocumentSection() {
  const { documents } = useActiveDataMutation();

  if (!documents?.length) return null;

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="document-section" className="border-none">
        <AccordionTrigger className="text-b2-mid font-medium hover:no-underline px-0 py-3 justify-start! gap-2 items-center [&>svg]:translate-y-0">
          Uploaded Documents
        </AccordionTrigger>
        <AccordionContent className="px-0 pb-0">
          <div className="flex flex-wrap gap-3 pl-2">
            {documents.map((document: any) => (
              <ChildDocumentCard key={document.id} document={document} />
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
